import { Link } from "react-router-dom";
import { CONTACT_EMAIL, SITE_ORIGIN } from "../config/site";
import { BtnContent } from "../components/BtnIcon";
import { IoStorefrontOutline } from "react-icons/io5";

function Returns() {
  const lastUpdated = "July 10, 2026";

  return (
    <article className="container py-4 py-md-5" style={{ maxWidth: "720px" }}>
      <header className="mb-4">
        <h1 className="h3 mb-2">Return &amp; refund policy</h1>
        <p className="text-muted small mb-0">Last updated: {lastUpdated}</p>
      </header>

      <p className="small mb-4">
        Rencin Gifting (&ldquo;we&rdquo;, &ldquo;us&rdquo;, or &ldquo;our&rdquo;) wants you to be
        happy with your gift box purchase. This policy explains returns, exchanges, and refunds for
        orders placed on{" "}
        <a href={SITE_ORIGIN}>{SITE_ORIGIN.replace(/^https?:\/\//, "")}</a>.
      </p>

      <section className="mb-4">
        <h2 className="h5 mb-2">Return window</h2>
        <p className="small mb-0">
          You may request a return within <strong>7 days</strong> of delivery for eligible
          products in unused, resaleable condition with original packaging intact. Contact us as soon
          as possible if something is not right — delays beyond this window may limit what we can
          offer.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Eligible items</h2>
        <ul className="small ps-3 mb-0">
          <li className="mb-1">Standard gift boxes that are unused and in original condition.</li>
          <li className="mb-1">
            Items that arrived damaged, defective, or materially different from what was ordered.
          </li>
          <li>
            Wrong item shipped by us (we will arrange a replacement or refund after verification).
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Non-returnable items</h2>
        <ul className="small ps-3 mb-0">
          <li className="mb-1">
            <strong>Personalised gift boxes</strong> — orders with a custom lid message, layout, or
            other personalisation made at your request.
          </li>
          <li className="mb-1">Products marked as final sale or non-returnable on the product page.</li>
          <li className="mb-1">Items that show signs of use, assembly, or damage after delivery.</li>
          <li>Perishable or consumable contents inside hampers, once opened.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">How to request a return</h2>
        <p className="small mb-2">
          Email <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> with:
        </p>
        <ul className="small ps-3 mb-2">
          <li className="mb-1">Your order number and the email used at checkout</li>
          <li className="mb-1">A brief description of the issue</li>
          <li>Clear photos of the product and packaging (required for damage or defect claims)</li>
        </ul>
        <p className="small mb-0">
          We will review your request and reply with next steps, including whether a return pickup,
          self-ship return, replacement, or refund applies.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Refunds</h2>
        <p className="small mb-2">
          Approved refunds are processed to the original payment method where possible. For prepaid
          UPI orders, refunds are typically initiated within 5–10 business days after we approve the
          return; your bank or UPI app may take additional time to credit the amount.
        </p>
        <p className="small mb-0">
          Shipping charges are non-refundable unless the return is due to our error (wrong item,
          defective product, or significant damage in transit). COD orders refunded after delivery
          are handled case by case.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Exchanges</h2>
        <p className="small mb-0">
          If you would prefer a different colour or box style, contact us within the return window.
          Exchanges depend on stock availability. You may need to place a new order and return the
          original item, or we may offer a partial solution — we will confirm by email.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Cancellations</h2>
        <p className="small mb-0">
          Orders can be cancelled before dispatch. Once personalisation has started or the parcel has
          been handed to the courier, cancellation may not be possible. Email us immediately with
          your order number if you need to cancel.
        </p>
      </section>

      <section className="mb-4">
        <h2 className="h5 mb-2">Contact us</h2>
        <p className="small mb-0">
          For returns, refunds, or order issues, email{" "}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a> or visit our{" "}
          <Link to="/about">contact page</Link>. See also our{" "}
          <Link to="/shipping">shipping policy</Link> for delivery and damage-in-transit guidance.
        </p>
      </section>

      <p className="mb-0">
        <Link to="/shop" className="btn btn-primary btn-sm">
          <BtnContent icon={IoStorefrontOutline}>Back to shop</BtnContent>
        </Link>
      </p>
    </article>
  );
}

export default Returns;
